import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useUnusableTimeZone } from '@/shared/hooks/useSessionTimeZone';

/**
 * The server validates a tenant's zone with the platform's time-zone database and the console
 * formats with the browser's own (`AM-253`, `AM-282`): a zone one accepts the other may not know,
 * and every date then comes out in Buenos Aires. This says so, discreetly, above the content of
 * each shell; it renders nothing while the zone is one this browser knows.
 */
export function UnknownTimeZoneNotice() {
  const { t } = useTranslation('common');
  const zone = useUnusableTimeZone();

  if (zone === null) {
    return null;
  }

  return (
    <Text role="status" size="xs" c="dimmed" mb="xs">
      {t('timeZone.unknown', { zone })}
    </Text>
  );
}
